/**
 * @file   传说
 * @create macaiqi 2025/04/30
 * @update 
 */
import React, { useState } from 'react';
import cls from 'classnames';
import gq from '../../../assets/images/gq.jpg';
import gq1 from '../../../assets/images/gq1.png';
import gq2 from '../../../assets/images/gq2.png';
import gq3 from '../../../assets/images/gq3.png';
import gq4 from '../../../assets/images/gq4.png';
import gq1Active from '../../../assets/images/gq1-a.png';
import gq2Active from '../../../assets/images/gq2-a.png';
import gq3Active from '../../../assets/images/gq3-a.png';
import gq4Active from '../../../assets/images/gq4-a.png';
import kgfximg from '../../../assets/images/kgfx.jpg';

import './index.scss'

export default function Legend({ setShow }) {
    const [active, setActive] = useState()
    const [showkgfx, setShowkgfx] = useState()
    let activearr = [gq1Active, gq2Active, gq3Active, gq4Active]
    return (
        <div className=' common-page legend-page '>
            <img src={gq} alt="" />
            <i className="back" onClick={() => { setShow() }}></i>

            <div className="list">
                {[gq1, gq2, gq3, gq4].map((item, index) => {
                    return (
                        <div className={cls("imgbox", { active: active === index })} key={index}>
                            <img src={active === index ? activearr[index] : item} alt="" onClick={() => { setActive(index) }} className={active === index ? 'active' : ''} />
                            {active === 0 && index === 0 && <div className={cls('txt txt0  animate__animated  fadeInUpLittle')}>
                                <p>《琴操》载：“伏羲作琴。”相传，在远古洪荒时代，伏羲氏居住于东方大地，他通过观察天地万象，洞悉万物生长的规律。一日，伏羲见风吹树叶发出和谐的声音，又听流水击石所形成的节奏，受到启发，决定制作一种能表达大自然美妙声音的乐器‌。</p>
                                <p>伏羲首次尝试制作的是无弦之琴，以普通木材仿照风声水韵制成，但这种琴仅靠风或水击打才能发声，显然不能满足长久演奏的需求。于是，伏羲不断寻找合适的材料和方法。在一次机缘巧合下，伏羲发现凤凰落在梧桐树上，梧桐木坚韧轻盈，富有音乐共鸣。于是，伏羲根据凤凰的形象以及梧桐木的特点，开始打造全新的乐器‌。</p>
                                <p>关于伏羲制琴的具体细节，传说中伏羲在制作过程中得到了女娲的帮助，用她的秀发作为琴弦，使得琴音悠扬悦耳，这便形成了最初的单弦琴，也就是后来的伏羲式古琴雏形‌。此外，还有传说称伏羲在制作过程中受到凤凰栖于梧桐树的启发，截取梧桐木的中段，按照四时八节之数制作琴胚和底板，最终制作出了古琴‌。</p>
                            </div>}
                            {active === 1 && index === 1 && <div className={cls('txt txt0   animate__animated  fadeInUpLittle')}>
                                <p>汉代桓谭《新论·琴道》中曾记载：“昔神农氏继宓羲而王天下，亦上观于。法于天，下取法于地，仅取诸身，远取诸物。于是始削桐为琴，绳丝为弦，以通神明之道，合天地之和焉。”</p>
                                <p>相传，神农氏作为农业和医药的祖先，发明古琴是为了表达自己的丰收喜悦和对大自然的感激之情，同时，古琴也被用于祭祀等重要活动，成为人们与神灵沟通的工具之一。</p>
                            </div>}
                            {active === 2 && index === 2 && <div className={cls('txt txt0  animate__animated  fadeInUpLittle')}>
                                <p>司马迁《史记·五帝本纪》记载，“帝尧问可用者，四岳咸荐虞舜，曰：可。于是尧乃以二女妻舜，以观其内；使九男与处，以观其外……舜耕历山，历山之人皆让畔……一年而所居成聚，二年成邑，三年成都。尧乃赐舜。絺衣与琴，为筑仓廪，予牛羊。”</p>
                                <p>这段记载讲述了帝尧曾将琴作为赏赐之物赠予舜的故事。</p>
                            </div>}
                            {active === 3 && index === 3 && <div className={cls('txt txt0  animate__animated  fadeInUpLittle')}>
                                <p>司马迁《史记·乐书》记载，“昔者舜作五弦之琴，以歌南风；夔始作乐，以赏诸侯。”</p>
                                <p>桓谭《新论》中记载：“神农之琴，以纯丝做弦，刻桐木为琴。至五帝时，始改为八尺六寸。虞舜改为五弦，文王武王改为七弦。”</p>
                                <p>有学者认为，以上记述说明舜作五弦之琴以前就有琴了，不然古琴很难刚一出现就能声具五音并且还能与歌唱伴奏。琴张五弦应该是古琴第一次发展的明证。武王诛纣建立周朝后，古琴由五弦之琴发展为七弦琴。</p>
                            </div>}
                        </div>
                    )
                })}
            </div>
            <i className="qin" onClick={() => {
                setShowkgfx(true)
            }}></i>

            {showkgfx && <div className="common-page  kgfx-page ">
                <img src={kgfximg} alt="" srcset="" />
                <i className="back" onClick={() => { setShowkgfx(false) }}></i>

            </div>}
        </div>
    )
}
